module.exports = __webpack_public_path__ + "media/invoices.bf26507d.mp4";